import script from "./InitialTrial.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialTrial.vue?vue&type=script&setup=true&lang=js"

import "./InitialTrial.vue?vue&type=style&index=0&id=067cffcb&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-067cffcb"]])

export default __exports__